import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  SERVICES,
  VERSIONS,
  RESOURCES
} from '../common/constants';

// Define the base endpoint for market price
const MARKET_PRICE_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.MARKET_PRICE, // Use RESOURCES.MARKET_PRICE
  false // No tenant ID in the base URL
);

export const marketpriceApi = {
  createMarketPriceForm: tenantId => apiClient.get(`${MARKET_PRICE_BASE}/form`),

  editMarketPriceForm: (tenantId, Id) =>
    apiClient.get(`${MARKET_PRICE_BASE}/form?is_edit=true&market_id=${Id}`),

  submitMarketPrice: (tenantId, combinedData) =>
    apiClient.post(`${MARKET_PRICE_BASE}`, combinedData),

  updateMarketPriceForm: (tenantId, combinedData, market_price_location_id) =>
    apiClient.put(
      `${MARKET_PRICE_BASE}?market_price_location_id=${market_price_location_id}`,
      combinedData
    )
};
